(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.isOpen = false;
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.elements.button?.addEventListener('click', this.onButtonClick);
      this.addEventListener('keyup', this.onContainerKeyUp);
      document.addEventListener('click', this.onDocumentClick);

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    disconnectedCallback() {
      this.elements.button?.removeEventListener('click', this.onButtonClick);
      this.removeEventListener('keyup', this.onContainerKeyUp);
      document.removeEventListener('click', this.onDocumentClick);
    }

    hidePanel() {
      if (!this.elements.button || !this.elements.panel || !this.isOpen) return;
      this.isOpen = false;
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      if (!this.elements.button || !this.elements.panel || this.isOpen) return;
      this.isOpen = true;
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    onButtonClick(event) {
      event.preventDefault();

      if (!this.elements.button || !this.elements.panel) return;

      if (this.isOpen) {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onDocumentClick(event) {
      if (this.isOpen && !this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.classList.remove('color-background-3');
        this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transition = 'background var(--duration-short)';
        if (this.header.classList.contains('color-background-1')) {
          this.header.classList.add('color-background-3');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden', 'color-background-3');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains('color-background-1')) {
        this.header.classList.add('color-background-3');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia && activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }
/* Left-hand thumbnails. The theme retains ownership of its main Swiper. */
if (!customElements.get('hp-product-thumbnails')) {
  customElements.define('hp-product-thumbnails', class extends HTMLElement {
    connectedCallback() {
      if (this.mounted) return;
      this.gallery = this.closest('.product__media-wrapper');
      this.outer = this.closest('.product__outer');
      if (!this.gallery || !this.outer || this.closest('quick-add-modal')) return;

      this.mounted = true;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.buttons = new Map();
      this.originalImageSizes = new Map();
      this.signature = '';
      this.activeKey = null;
      this.needsActiveReveal = true;
      this.retries = 0;
      this.lastWidth = 0;
      this.lastHeight = 0;
      this.trackId = `${this.closest('[id^="MainProduct-"]')?.id || 'product'}-hp-thumbnails`;
      this.refreshSoon = () => {
        if (!this.frame && this.isConnected) {
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.refresh();
          });
        }
      };
      this.sync = () => this.syncActive();
      this.onDestroy = () => {
        this.retries = 0;
        this.unbindSwiper();
        this.setEnabled(false);
        this.refreshSoon();
      };
      this.onBreakpoint = () => {
        this.retries = 0;
        this.needsActiveReveal = true;
        this.refreshSoon();
        this.updateSoon();
      };
      this.onClick = (event) => {
        const button = event.target.closest('button[data-hp-media-key]');
        if (!button || !this.contains(button) || !this.enabled) return;
        event.preventDefault();
        this.needsActiveReveal = true;
        this.goToMedia(button.dataset.hpMediaKey);
      };
      this.onFocus = (event) => {
        const button = event.target.closest('button[data-hp-media-key]');
        if (button && this.contains(button)) this.revealButton(button, false);
      };
      this.onKeyDown = (event) => {
        const current = event.target.closest('button[data-hp-media-key]');
        if (!current || !this.contains(current) || !this.enabled) return;
        if (!['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        const buttons = Array.from(this.buttons.values());
        let index = buttons.indexOf(current);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = buttons.length - 1;
        else index += event.key === 'ArrowDown' ? 1 : -1;
        event.preventDefault();
        event.stopPropagation();
        buttons[Math.max(0, Math.min(buttons.length - 1, index))]?.focus({ preventScroll: true });
        // Enter/Space activate the focused thumbnail using its normal button click.
      };
      this.onMediaLoad = (event) => {
        if (!this.contains(event.target) && event.target.tagName === 'IMG') this.updateSoon();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('focusin', this.onFocus);
      this.addEventListener('keydown', this.onKeyDown);
      this.desktop.addEventListener('change', this.onBreakpoint);
      window.addEventListener('load', this.refreshSoon);
      this.gallery.addEventListener('load', this.onMediaLoad, true);

      this.onMainClick = (event) => {
        const main = this.getMainElement();
        if (!this.enabled || !main?.contains(event.target)) return;
        const arrow = event.target.closest('[data-hp-main-step]');
        if (arrow) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!arrow.disabled && arrow.getAttribute('aria-disabled') !== 'true') {
            this.stepMainPhoto(Number(arrow.dataset.hpMainStep));
          }
          return;
        }
        // A completed drag must not become a click on the full-image zoom button.
        if (event.detail > 0 && performance.now() < (this.suppressMainClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.onMainPointerDown = (event) => this.startMainDrag(event);
      this.onMainPointerMove = (event) => this.moveMainDrag(event);
      this.onMainPointerUp = (event) => {
        if (event.pointerId === this.mainDrag?.pointerId) this.finishMainDrag(false);
      };
      this.onMainPointerCancel = (event) => {
        if (event.pointerId === this.mainDrag?.pointerId) this.finishMainDrag(true);
      };
      this.onMainBlur = () => this.finishMainDrag(true);
      this.onMainDragStart = (event) => {
        if (this.enabled && this.getMainElement()?.contains(event.target) &&
            event.target.closest('.product__modal-opener--image')) event.preventDefault();
      };
      this.gallery.addEventListener('click', this.onMainClick, true);
      this.gallery.addEventListener('pointerdown', this.onMainPointerDown, true);
      this.gallery.addEventListener('dragstart', this.onMainDragStart, true);
      window.addEventListener('blur', this.onMainBlur);

      this.observer = new MutationObserver((changes) => {
        // Ignore our own buttons. Keep up with variant/gallery replacements.
        if (changes.some((change) => !this.contains(change.target))) this.refreshSoon();
      });
      this.observer.observe(this.gallery, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'data-media-id', 'src', 'srcset', 'hidden']
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          const main = this.getMainElement();
          const width = main?.clientWidth || 0;
          const height = main?.clientHeight || 0;
          const widthChanged = Math.abs(width - this.lastWidth) > 0.5;
          const heightChanged = Math.abs(height - this.lastHeight) > 0.5;
          if (widthChanged || heightChanged) {
            this.lastWidth = width;
            this.lastHeight = height;
            this.needsActiveReveal = true;
            if (widthChanged) this.updateSoon();
            else this.refreshSoon();
          }
        });
        this.resizeObserver.observe(this.gallery);
      }
      this.refresh();
    }

    disconnectedCallback() {
      if (!this.mounted) return;
      this.mounted = false;
      this.finishMainDrag(true);
      this.gallery.removeEventListener('click', this.onMainClick, true);
      this.gallery.removeEventListener('pointerdown', this.onMainPointerDown, true);
      this.gallery.removeEventListener('dragstart', this.onMainDragStart, true);
      window.removeEventListener('blur', this.onMainBlur);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.updateFrame);
      clearTimeout(this.retryTimer);
      this.frame = 0;
      this.updateFrame = 0;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.desktop.removeEventListener('change', this.onBreakpoint);
      window.removeEventListener('load', this.refreshSoon);
      this.gallery.removeEventListener('load', this.onMediaLoad, true);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('focusin', this.onFocus);
      this.removeEventListener('keydown', this.onKeyDown);
      this.unbindSwiper();
      this.setEnabled(false);
    }

    layoutRequested() {
      if (this.desktop.matches) return this.outer.classList.contains('product__outer--thumbs-aside');
      return this.dataset.leftOnMobile !== 'false' &&
        this.outer.classList.contains('product__gallery--thumbs_aside-mobile');
    }

    getMainElement() {
      return this.gallery.querySelector('.product__media-list-wrapper > .js-media-list, .product__media-list-wrapper > .js-media-list-mobile');
    }

    unbindSwiper() {
      const swiper = this.swiper;
      if (swiper && !swiper.destroyed && typeof swiper.off === 'function') {
        swiper.off('slideChange', this.sync);
        swiper.off('transitionEnd', this.sync);
        swiper.off('update', this.refreshSoon);
        swiper.off('destroy', this.onDestroy);
      }
      this.swiper = null;
    }

    refresh() {
      if (!this.mounted || !this.isConnected) return;
      const main = this.getMainElement();
      const swiper = main?.swiper;
      if (!this.layoutRequested() || !swiper || swiper.destroyed ||
          !swiper.initialized || typeof swiper.slideTo !== 'function') {
        this.setEnabled(false);
        if (this.layoutRequested() && this.retries < 50) {
          clearTimeout(this.retryTimer);
          this.retryTimer = setTimeout(() => {
            this.retries += 1;
            this.refreshSoon();
          }, 100);
        }
        return;
      }
      clearTimeout(this.retryTimer);
      let newInstance = false;
      if (swiper !== this.swiper) {
        this.unbindSwiper();
        this.swiper = swiper;
        swiper.on('slideChange', this.sync);
        swiper.on('transitionEnd', this.sync);
        swiper.on('update', this.refreshSoon);
        swiper.on('destroy', this.onDestroy);
        this.resizeObserver?.observe(main);
        newInstance = true;
      }

      const nativeItems = new Map(Array.from(this.gallery.querySelectorAll('.product__media-subitem'))
        .map((item) => [item.getAttribute('data-media-sub-id'), item]));
      const seen = new Set();
      const records = [];
      Array.from(swiper.slides || []).forEach((slide, index) => {
        const key = slide.getAttribute('data-media-id');
        if (!key || seen.has(key) || slide.hidden || getComputedStyle(slide).display === 'none') return;
        seen.add(key);
        const image = nativeItems.get(key)?.querySelector('img') || slide.querySelector('img');
        records.push({
          key,
          src: image?.getAttribute('src') || '',
          srcset: image?.getAttribute('srcset') || '',
          alt: image?.getAttribute('alt') || '',
          order: swiper.params.loop
            ? Number(slide.getAttribute('data-swiper-slide-index') ?? index) : index
        });
      });
      if (!records.length || !records.some((record) => record.src)) {
        this.setEnabled(false);
        return;
      }
      records.sort((a, b) => a.order - b.order);
      const signature = JSON.stringify(records);
      if (signature !== this.signature) {
        const focusedKey = this.contains(document.activeElement)
          ? document.activeElement.dataset.hpMediaKey : null;
        const previousScroll = this.track?.scrollTop || 0;
        const row = document.createElement('div');
        row.className = 'hp-gallery-thumbnails';
        row.id = this.trackId;
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', this.dataset.groupLabel || 'Product images');
        this.buttons.clear();
        records.forEach((record, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hp-gallery-thumbnail';
          button.dataset.hpMediaKey = record.key;
          const label = (this.dataset.imageLabel || 'Show media [n]').replace('[n]', String(index + 1));
          button.setAttribute('aria-label', record.alt ? `${label} : ${record.alt}` : label);
          button.setAttribute('aria-pressed', 'false');
          if (record.src) {
            const image = document.createElement('img');
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 160;
            image.height = 160;
            const thumbSize = this.desktop.matches ? this.dataset.thumbSize : this.dataset.thumbSizeMobile;
            image.sizes = `${thumbSize || (this.desktop.matches ? 110 : 56)}px`;
            if (record.srcset) image.srcset = record.srcset;
            image.src = record.src;
            button.append(image);
          } else {
            button.textContent = String(index + 1);
          }
          this.buttons.set(record.key, button);
          row.append(button);
        });
        this.track = row;
        this.replaceChildren(row);
        row.scrollTop = previousScroll;
        this.signature = signature;
        this.needsActiveReveal = true;
        if (focusedKey && this.buttons.has(focusedKey)) this.buttons.get(focusedKey).focus({ preventScroll: true });
      }
      const wasEnabled = this.enabled;
      this.setEnabled(true);
      this.updateImageSizes();
      this.syncActive();
      if (newInstance || !wasEnabled) this.updateSoon();
    }

    revealButton(button, animate = true) {
      if (!this.enabled || !this.track || !button) return;
      const viewport = this.track.getBoundingClientRect();
      const rect = button.getBoundingClientRect();
      let distance = 0;
      if (rect.top < viewport.top + 4) distance = rect.top - viewport.top - 4;
      else if (rect.bottom > viewport.bottom - 4) distance = rect.bottom - viewport.bottom + 4;
      if (Math.abs(distance) > 1) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Scroll this column only, never the product page.
        this.track.scrollBy({ top: distance, behavior: animate && !reducedMotion ? 'smooth' : 'instant' });
      }
    }

    setEnabled(enabled) {
      const changed = !!this.enabled !== enabled;
      this.enabled = enabled;
      if (!enabled) this.finishMainDrag(true);
      this.outer?.classList.toggle('hp-gallery-ready', enabled);
      if (changed && enabled) this.needsActiveReveal = true;
      const native = this.gallery?.querySelector('.product__media-sublist-outer');
      if (this.nativeState && (!enabled || this.nativeState.node !== native)) {
        const { node, ariaHidden, inert } = this.nativeState;
        if (ariaHidden === null) node.removeAttribute('aria-hidden');
        else node.setAttribute('aria-hidden', ariaHidden);
        node.toggleAttribute('inert', inert);
        this.nativeState = null;
      }
      if (enabled && native && !this.nativeState) {
        this.nativeState = { node: native, ariaHidden: native.getAttribute('aria-hidden'), inert: native.hasAttribute('inert') };
        native.setAttribute('aria-hidden', 'true');
        native.setAttribute('inert', '');
      }
      if (!enabled) this.restoreImageSizes();
      if (changed && !enabled && this.isConnected) this.updateSoon();
    }

    restoreImageSizes() {
      this.originalImageSizes?.forEach((sizes, image) => {
        if (sizes === null) image.removeAttribute('sizes');
        else image.setAttribute('sizes', sizes);
      });
      this.originalImageSizes?.clear();
    }

    updateSoon() {
      if (this.updateFrame || !this.isConnected || !this.mounted) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = 0;
        const main = this.getMainElement()?.swiper;
        const native = this.gallery.querySelector('.js-media-sublist')?.swiper;
        if (native && !native.destroyed && !this.enabled) native.update();
        if (main && !main.destroyed) {
          main.update();
          if (main.params.autoHeight) main.updateAutoHeight(0);
        }
        this.updateImageSizes();
        this.syncActive();
      });
    }

    updateImageSizes() {
      if (!this.enabled) return;
      const main = this.getMainElement();
      if (!main) return;
      // Keep the same high-resolution sources; only report actual display size.
      main.querySelectorAll('.product__media img').forEach((image) => {
        const width = image.clientWidth;
        const height = image.clientHeight;
        if (!width || !image.getAttribute('srcset')) return;
        const frame = image.closest('.product__media');
        const sourceWidth = Number(frame?.dataset.hpOriginalWidth || image.getAttribute('width'));
        const sourceHeight = Number(frame?.dataset.hpOriginalHeight || image.getAttribute('height'));
        const ratio = sourceWidth > 0 && sourceHeight > 0 ? sourceWidth / sourceHeight : 1;
        let required = width;
        const fit = getComputedStyle(image).objectFit;
        if (height > 0 && fit === 'cover') required = Math.max(width, height * ratio);
        if (height > 0 && fit === 'contain') required = Math.min(width, height * ratio);
        const sizes = `${Math.max(1, Math.ceil(required))}px`;
        if (!this.originalImageSizes.has(image)) this.originalImageSizes.set(image, image.getAttribute('sizes'));
        if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
      });
      this.buttons.forEach((button) => {
        const image = button.querySelector('img');
        const width = button.clientWidth;
        if (image && width > 0) image.sizes = `${Math.ceil(width)}px`;
      });
    }

    updateMainNavigation() {
      const main = this.getMainElement();
      const swiper = main?.swiper;
      if (!main || !swiper || swiper.destroyed || !this.enabled) return;
      const keys = Array.from(this.buttons.keys());
      const key = swiper.slides?.[swiper.activeIndex]?.getAttribute('data-media-id');
      const index = keys.indexOf(key);
      const wrap = !!(swiper.params.loop || swiper.params.rewind);
      main.classList.toggle('hp-main-single', keys.length < 2);
      main.querySelectorAll('[data-hp-main-step]').forEach((button) => {
        const previous = Number(button.dataset.hpMainStep) < 0;
        const unavailable = keys.length < 2 || index < 0 || swiper.enabled === false ||
          (!wrap && (previous ? index === 0 : index === keys.length - 1));
        if (button.disabled !== unavailable) button.disabled = unavailable;
        const value = String(unavailable);
        if (button.getAttribute('aria-disabled') !== value) button.setAttribute('aria-disabled', value);
        button.tabIndex = unavailable ? -1 : 0;
        button.classList.toggle('swiper-button-disabled', unavailable);
      });
    }

    stepMainPhoto(step) {
      const swiper = this.getMainElement()?.swiper;
      if (!this.enabled || !swiper || swiper.destroyed || swiper.enabled === false) return false;
      const keys = Array.from(this.buttons.keys());
      const key = swiper.slides?.[swiper.activeIndex]?.getAttribute('data-media-id');
      const index = keys.indexOf(key);
      if (keys.length < 2 || index < 0) return false;
      let target = index + (step < 0 ? -1 : 1);
      if (target < 0 || target >= keys.length) {
        if (!swiper.params.loop && !swiper.params.rewind) return false;
        target = (target + keys.length) % keys.length;
      }
      this.needsActiveReveal = true;
      this.goToMedia(keys[target]);
      return true;
    }

    startMainDrag(event) {
      // Native touch gestures remain owned by Swiper. This handler is mouse-only.
      if (!this.enabled || !this.desktop.matches || event.pointerType !== 'mouse' ||
          event.button !== 0 || event.isPrimary === false || this.buttons.size < 2) return;
      const main = this.getMainElement();
      const swiper = main?.swiper;
      if (!main?.contains(event.target) || !swiper || swiper.destroyed ||
          swiper.enabled === false || swiper.animating ||
          !event.target.closest('.product__modal-opener--image') ||
          event.target.closest('[data-hp-main-step], a, input, textarea, select')) return;
      this.finishMainDrag(true);
      this.suppressMainClickUntil = 0;
      const canFollow = !swiper.params.cssMode && (!swiper.params.effect || swiper.params.effect === 'slide') &&
        typeof swiper.getTranslate === 'function' && typeof swiper.setTranslate === 'function' &&
        typeof swiper.setTransition === 'function';
      this.mainDrag = {
        pointerId: event.pointerId, main, swiper,
        startX: event.clientX, startY: event.clientY, dx: 0, dy: 0,
        index: swiper.activeIndex, translate: canFollow ? swiper.getTranslate() : 0,
        canFollow, moved: false, horizontal: false,
        rtl: !!swiper.rtlTranslate || getComputedStyle(main).direction === 'rtl'
      };
      // Prevent a second mouse drag in Swiper and the browser's image-drag ghost.
      // A stationary click still activates the existing zoom button.
      event.preventDefault();
      event.stopImmediatePropagation();
      document.addEventListener('pointermove', this.onMainPointerMove, { capture: true, passive: false });
      document.addEventListener('pointerup', this.onMainPointerUp, true);
      document.addEventListener('pointercancel', this.onMainPointerCancel, true);
    }

    moveMainDrag(event) {
      const drag = this.mainDrag;
      if (!drag || event.pointerId !== drag.pointerId) return;
      if ((event.buttons & 1) === 0 || drag.swiper.destroyed) {
        this.finishMainDrag(true);
        return;
      }
      drag.dx = event.clientX - drag.startX;
      drag.dy = event.clientY - drag.startY;
      if (Math.max(Math.abs(drag.dx), Math.abs(drag.dy)) >= 8) drag.moved = true;
      if (!drag.horizontal && Math.abs(drag.dx) >= 8 && Math.abs(drag.dx) > Math.abs(drag.dy)) {
        drag.horizontal = true;
        drag.main.classList.add('hp-is-dragging');
        if (drag.canFollow) drag.swiper.setTransition(0);
      }
      if (drag.horizontal && drag.canFollow) {
        let translate = drag.translate + drag.dx * (drag.rtl ? -1 : 1);
        if (!drag.swiper.params.loop && typeof drag.swiper.minTranslate === 'function' &&
            typeof drag.swiper.maxTranslate === 'function') {
          const a = drag.swiper.minTranslate();
          const b = drag.swiper.maxTranslate();
          translate = Math.max(Math.min(a, b), Math.min(Math.max(a, b), translate));
        }
        drag.swiper.setTranslate(translate);
      }
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    finishMainDrag(cancelled) {
      const drag = this.mainDrag;
      if (!drag) return;
      this.mainDrag = null;
      document.removeEventListener('pointermove', this.onMainPointerMove, true);
      document.removeEventListener('pointerup', this.onMainPointerUp, true);
      document.removeEventListener('pointercancel', this.onMainPointerCancel, true);
      drag.main.classList.remove('hp-is-dragging');
      if (drag.moved) this.suppressMainClickUntil = performance.now() + 500;
      if (drag.swiper.destroyed || !drag.horizontal) return;
      const threshold = Math.max(30, Math.min(80, drag.main.clientWidth * 0.12));
      const longEnough = !cancelled && Math.abs(drag.dx) >= threshold;
      const next = (drag.rtl ? -drag.dx : drag.dx) < 0;
      const advanced = longEnough && this.stepMainPhoto(next ? 1 : -1);
      if (!advanced) {
        const duration = cancelled || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200;
        drag.swiper.slideTo(drag.index, duration);
      }
      this.syncActive();
    }

    goToMedia(key) {
      const swiper = this.getMainElement()?.swiper;
      if (!swiper || swiper.destroyed) { this.refreshSoon(); return; }
      const slides = Array.from(swiper.slides || []);
      let index = slides.findIndex((slide) => slide.getAttribute('data-media-id') === key &&
        !slide.classList.contains('swiper-slide-duplicate'));
      if (index < 0) index = slides.findIndex((slide) => slide.getAttribute('data-media-id') === key);
      if (index < 0) return;
      const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250;
      const rawRealIndex = slides[index].getAttribute('data-swiper-slide-index');
      const realIndex = rawRealIndex === null ? NaN : Number(rawRealIndex);
      if (swiper.params.loop && typeof swiper.slideToLoop === 'function' && Number.isInteger(realIndex)) {
        swiper.slideToLoop(realIndex, duration);
      } else { swiper.slideTo(index, duration); }
      this.syncActive();
    }

    syncActive() {
      const swiper = this.getMainElement()?.swiper;
      if (!swiper || swiper.destroyed || !this.enabled) return;
      this.updateMainNavigation();
      const key = swiper.slides?.[swiper.activeIndex]?.getAttribute('data-media-id');
      if (!key) return;
      const changed = key !== this.activeKey;
      this.activeKey = key;
      this.buttons.forEach((button, mediaKey) => {
        const pressed = String(mediaKey === key);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      });
      if (changed || this.needsActiveReveal) {
        this.needsActiveReveal = false;
        this.revealButton(this.buttons.get(key), changed);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
